// Schema.org structured data for SEO
// All structured-data URLs ALWAYS resolve to the apex canonical domain,
// regardless of which host the visitor or crawler hits (www / preview / .com).
import { CANONICAL_BASE_URL } from './../config/site';

const getBaseUrl = () => CANONICAL_BASE_URL;

export const getOrganizationSchema = () => {
  const baseUrl = getBaseUrl();
  return {
    '@context': 'https://schema.org',
    '@type': 'AccountingService',
    '@id': `${baseUrl}/#organization`,
    name: 'Brightson Accounting Limited',
    url: baseUrl,
    logo: `${baseUrl}/logo.png`,
    description:
      'Professional accounting services in Wolverhampton. FCCA & MAAT qualified accountant with 15+ years experience providing tax returns, bookkeeping, and company accounts for small businesses.',
    email: 'info@brightsonaccounting.co.uk',
    telephone: '+447362982967',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '71-75 Shelton Street, Covent Garden',
      addressLocality: 'London',
      postalCode: 'WC2H 9JQ',
      addressCountry: 'UK',
    },
    areaServed: [
      {
        '@type': 'City',
        name: 'Wolverhampton',
      },
      {
        '@type': 'City',
        name: 'Birmingham',
      },
      {
        '@type': 'City',
        name: 'Coventry',
      },
      {
        '@type': 'City',
        name: 'Leicester',
      },
      {
        '@type': 'City',
        name: 'London',
      },
    ],
    priceRange: '££',
    foundingDate: '2010',
    slogan: 'Less Tax. Less Stress. No HMRC Trouble.',
    sameAs: [],
  };
};

export const getLocalBusinessSchema = () => {
  const baseUrl = getBaseUrl();
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${baseUrl}/#localbusiness`,
    name: 'Brightson Accounting Limited',
    image: `${baseUrl}/logo.png`,
    url: baseUrl,
    telephone: '+447362982967',
    email: 'info@brightsonaccounting.co.uk',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '71-75 Shelton Street, Covent Garden',
      addressLocality: 'London',
      addressRegion: 'Greater London',
      postalCode: 'WC2H 9JQ',
      addressCountry: 'UK',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 51.5145,
      longitude: -0.1227,
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '17:00',
    },
    priceRange: '££',
  };
};

export const getProfessionalServiceSchema = () => {
  const baseUrl = getBaseUrl();
  return {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'Brightson Accounting Limited',
    image: `${baseUrl}/logo.png`,
    url: baseUrl,
    email: 'info@brightsonaccounting.co.uk',
    telephone: '+447362982967',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '71-75 Shelton Street, Covent Garden',
      addressLocality: 'London',
      addressRegion: 'Greater London',
      postalCode: 'WC2H 9JQ',
      addressCountry: 'UK',
    },
    priceRange: '££',
    areaServed: {
      '@type': 'GeoCircle',
      geoMidpoint: {
        '@type': 'GeoCoordinates',
        latitude: 52.5862,
        longitude: -2.1283,
      },
      geoRadius: '50000',
    },
  };
};

export const getServiceSchema = (serviceName, description) => {
  const baseUrl = getBaseUrl();
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: serviceName,
    description: description,
    provider: {
      '@type': 'AccountingService',
      name: 'Brightson Accounting Limited',
      url: baseUrl,
    },
    areaServed: {
      '@type': 'City',
      name: 'Wolverhampton',
    },
  };
};

export const getFAQSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
});

export const getBreadcrumbSchema = (items) => {
  const baseUrl = getBaseUrl();
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url ? `${baseUrl}${item.url}` : undefined,
    })),
  };
};
